import React from 'react';
import PropTypes from 'prop-types';
import { trackFeatureUsage } from '@animoto/utils/analytics';
import {
  HeaderMedium,
  HeaderExtraSmall
} from '@animoto/components/lib/es/design-system';

import animotoPlansPricing from './assets/animoto-plans-pricing.png';
import gettingStarted from './assets/getting-started.png';
import workLife from './assets/work-life.jpg';
import './BlogPosts.module.css';

const blogs = [
  {
    image : gettingStarted,
    style : 'getting-started',
    title : 'Complete Guide to Getting Started with Animoto',
    url   : '/blog/guides/getting-started-animoto'
  },
  {
    image : workLife,
    style : 'work-and-life',
    title : '10 Most Popular Video Templates for Work and Life',
    url   : '/blog/video-ideas/most-popular-video-templates-work-life'
  },
  {
    image : animotoPlansPricing,
    style : 'animoto-plans-pricing',
    title : 'Quiz: Find the Right Animoto Plan for You',
    url   : '/blog/news/animoto-news/animoto-plans-pricing'
  }
];
export default function BlogPosts({ isMiddleSize }) {
  const onClickBlog = (url) => {
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'Blog-Posts',
      action  : `click:${url}`
    });
  };

  const generateBlogs = () => blogs.map(({
    url,
    style,
    title,
    image
  }) => (
    <div key={style} styleName="blog-wrapper">
      <a href={url} onClick={() => onClickBlog(url)} rel="noopener noreferrer" styleName="blog" target="_blank">
        <img
          alt={style}
          height={isMiddleSize ? '99' : '72'}
          src={image}
          styleName="image"
          value={url}
          width={isMiddleSize ? '148' : '108'}
        />
      </a>
      <a href={url} onClick={() => onClickBlog(url)} rel="noopener noreferrer" styleName="blog" target="_blank">
        <HeaderExtraSmall
          styleName="blog-title"
          value={url}
        >{title}
        </HeaderExtraSmall>
      </a>
    </div>
  ));

  return (
    <div styleName="wrap">
      <div styleName="header-wrap">
        <HeaderMedium styleName="header">Featured Blog Posts</HeaderMedium>
        <div styleName="wave" />
      </div>
      <div styleName="blogs-wrapper">
        {generateBlogs()}
      </div>
    </div>
  );
}

BlogPosts.propTypes = {
  isMiddleSize : PropTypes.bool.isRequired
};
